import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

const SLIDE_ITEMS = {
  '(max-width: 599.99px) and (orientation: portrait)': 1,
  '(max-width: 959.99px) and (orientation: landscape)': 2,
  '(min-width: 600px) and (max-width: 839.99px) and (orientation: portrait)': 2,
  '(min-width: 960px) and (max-width: 1279.99px) and (orientation: landscape)': 2
};


@Component({
  selector: 'app-plan-slide',
  templateUrl: './plan-slide.component.html',
  styleUrls: ['./plan-slide.component.scss']
})
export class PlanSlideComponent implements OnInit {

  @Output() choosePlan: EventEmitter<any>;
  @Input() selectedPlan: string;
  @Input() planType: string = 'PERSONAL';
  @Input() itemsPerSlide: number = 4;
  plans: Array<any> = [];
  slideItemPage = 4;
  slide: any;

  constructor(
    private breakpoint: BreakpointObserver,
  ) {


    this.choosePlan = new EventEmitter();
    this.breakpoint
      .observe([
        Breakpoints.Handset,
        Breakpoints.Tablet
      ])
      .subscribe(
        result => {

          const { breakpoints } = result;
          for (let key in breakpoints) {
            if (breakpoints[key]) {
              this.slideItemPage = SLIDE_ITEMS[key];
              break;
            }
          }
        }
      );
        

  }

  private isMobile(): boolean {
    return this.breakpoint.isMatched(Breakpoints.Handset) || this.breakpoint.isMatched(Breakpoints.Tablet);
  }

  ngOnInit(): void {

    this.slideItemPage = this.itemsPerSlide > 2 ? this.itemsPerSlide : 2;
    if (this.slideItemPage === 4 && this.isMobile()) {
      this.slideItemPage = 2;
    }

    setTimeout(() => {

      this.slide = new (<any>window).Splide('#plans', {
        type: 'slide',
        perPage: this.slideItemPage,
        rewind: true,
        focus: false,
        arrows: false
        // width: '500px'
      });

      this.slide.mount();
      setTimeout(() => {
        const planIndex = this.plans.findIndex(plan => plan.code === this.selectedPlan);
        if (planIndex !== -1) {
          this.slide.go(planIndex);
        }
      }, 1000);

    })

    this.plans = this.planType == 'PERSONAL' ? [
      // {
      //   index: 1,
      //   code: 'YEARLY',
      //   title: 'Plano Anual',
      //   price: '49,90',
      //   period: 'anual',
      //   selected: false
      // },
      {
        index: 0,
        code: 'MONTHLY',//mesmo que o plano anual, mas aparece como grátis para o usuário
        title: 'Plano Free',
        price: '0,00',
        period: 'trimestral',
        selected: false
      },
    ] : [
      // {
      //   index: 1,
      //   code: 'FREE_BUSINESS',
      //   title: 'Plano Free empresarial',
      //   price: '0,00',
      //   period: 'mensal',
      //   selected: false
      // },
      {
        index: 1,
        code: 'MONTHLY_BUSINESS',
        title: 'Plano Mensal empresarial',
        price: '526,97',
        //descont: '25% OFF',
        period: 'mensal',
        selected: false
      },
      {
        index: 2,
        code: 'TREEMONTHLY_BUSINESS',
        title: 'Plano Trimestral empresarial',
        price: '1.422,81',
        descont: '10% OFF',
        period: 'trimestral',
        selected: false
      },
      {
        index: 3,
        code: 'SIXMONTHLY_BUSINESS',
        title: 'Plano Semestral empresarial',
        price: '2.687,54',
        descont: '15% OFF',
        period: 'semestral',
        selected: false
      },
      {
        index: 4,
        code: 'YEARLY_BUSINESS',
        title: 'Plano Anual empresarial',
        price: '5.058,91',
        descont: '20% OFF',
        period: 'anual',
        selected: false
      },
      {
        index: 5,
        code: 'TREEMONTHLY_BUSINESS_PLUS',
        title: 'Plano Trimestral Plus IA',
        price: '1.287,69',
        // descont: '10% OFF',
        period: 'trimestral',
        selected: false
      }  
      
    ];

  }

  ngAfterViewInit() {
    const plan = this.plans.find(plan => this.selectedPlan === plan.code)
    if (plan)
      this.selectPlan(plan);
  }

  getPriceValue(price) {
    return (price as string).split(',')[0];
  }

  getPriceDetails(price) {
    return (price as string).split(',')[1];
  }

  selectPlanBy(index: number) {

    const plan: any = this.plans.find(plan => plan.index == index);
    if (plan) {
      plan.selected = true;
      this.selectPlan(plan);
    }

  }

  selectPlan(plan: any) {
    for (let plan of this.plans)
      plan.selected = false;
    plan.selected = true;
    this.choosePlan.emit(plan);
  }

  navigateToSelectedPlan(planIndex: number) {
    if (this.slide) {
      this.slide.go(planIndex);  
    }
  }

}
